import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import MainPage from '@/components/View/MainPage';
import Restaurant from '@/components/View/Meal/Restaurant';
import MealOrderMain from '@/components/View/Meal/MealOrderMain';
import MealOrderRecord from '@/components/View/Meal/MealOrderRecord.vue';
import SpaMain from '@/components/View/Spa/SpaMain';
import SpaReservedMain from '@/components/View/Spa/SpaReservedMain';
import SpaItems from '@/components/View/Spa/SpaItems';
import SpaCalendar from '@/components/View/Spa/SpaCalendar.vue';
import SpaReserved from '@/components/View/Spa/SpaReserved.vue';
import SpaRecord from '@/components/View/Spa/SpaRecord';
import News from '@/components/View/Spa/News';
import OrderOrReservation from '@/components/View/Meal/OrderOrReservation';
import MealMenu from '@/components/View/Meal/MealMenu';
import MealCustom from '@/components/View/Meal/MealCustom';
Vue.use(Router);

export default new Router({
  base: "/dev_sampo_client_web", //正式時要打開
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      children: [
        {
          path: '/MainPage',
          name: 'MainPage',
          component: MainPage
        },
        {
          path: '/MealOrderMain',
          name: 'MealOrderMain',
          component: MealOrderMain,
          children: [
            {
              path: '/MealOrderRecord',
              name: 'MealOrderRecord',
              component: MealOrderRecord
            },
            {
              path: '/Restaurant',
              name: 'Restaurant',
              component: Restaurant
            },
            {
              path: '/OrderOrReservation',
              name: 'OrderOrReservation',
              component: OrderOrReservation
            },
            {
              path: '/MealMenu',
              name: 'MealMenu',
              component: MealMenu
            },
            {
               path: '/MealCustom',
              name: 'MealCustom',
              component: MealCustom
            }
          ]
        },
        {
          path: '/SpaMain',
          name: 'SpaMain',
          component: SpaMain,
          children: [
            {
              path: '/SpaReservedMain',
              name: 'SpaReservedMain',
              component: SpaReservedMain
            },
            {
              path: '/SpaCalendar',
              name: 'SpaCalendar',
              component: SpaCalendar
            },
            {
              path: '/SpaReserved',
              name: 'SpaReserved',
              component: SpaReserved
            },
            {
              path: '/News',
              name: 'News',
              component: News
            },
            {
              path: '/SpaItems',
              name: 'SpaItems',
              component: SpaItems
            },
            {
              path: '/SpaRecord',
              name: 'SpaRecord',
              component: SpaRecord,
            },
          ]
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js